import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, ArrowUpRight } from "lucide-react";

/** Subtle, persistent nudge to the contact page (hidden on /contact). */
export const FloatingContactCTA = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname === "/contact") return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 300, damping: 24 }}
          className="fixed bottom-6 left-6 z-[115]"
        >
          <Link
            to="/contact"
            data-testid="floating-contact-cta"
            className="group flex items-center gap-3 pl-4 pr-5 py-3 rounded-full shadow-lg backdrop-blur-md transition-colors duration-300"
            style={{ background: "color-mix(in srgb, var(--surface) 82%, transparent)", border: "1px solid var(--accent)", color: "var(--text)" }}
          >
            <span className="flex items-center justify-center w-8 h-8 rounded-full" style={{ background: "var(--accent)", color: "var(--bg)" }}>
              <MessageCircle size={16} />
            </span>
            <span className="text-sm uppercase tracking-widest">Let&apos;s talk</span>
            <ArrowUpRight size={16} style={{ color: "var(--accent)" }} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingContactCTA;
